export enum RelationTypeEnum {
  FRIEND = 'FRIEND',
  BLOCK = 'BLOCK',
}
